<template>
<outcomes :outcomes_forest="outcomes_forest" :outcomes_trad="outcomes_trad" :section="section"></outcomes>
</template>

<script>
import programs from '../assets/programs.json'
import outcomes from '../components/outcomes'

export default {
  el: '#blog-post-demo',
  data() {
      return {
      outcomes_forest: programs[0].Academic,
      outcomes_trad: programs[1].Academic,
      section: 'Academic'
      }
  },
  components: {
      outcomes
  }
}
</script>